import * as moment from "moment";

export function cloneComposition(o) {
    let newObj;
    let i;

    if (moment.isMoment(o)) {
        return o.clone();
    }

    if (typeof o !== "object" || !o) return o;

    if ("[object Array]" === Object.prototype.toString.apply(o)) {
        newObj = [];
        for (i = 0; i < o.length; i += 1) {
            newObj[i] = cloneComposition(o[i]);
        }
        return newObj;
    }

    newObj = {};
    for (i in o) {
        if (o.hasOwnProperty(i)) {
            newObj[i] = cloneComposition(o[i]);
        }
    }

    return newObj;
}
